

























































































import CreateDialog from '@/components/CreateDialog.vue'
import { editMixin } from '@/utils/mixins/editMixin'
import { AgencyTopUpPrice } from '@/utils/interfaces/topup.interface'
import { getProducts, getProviders } from '@/api/Topup/topup.api'
import { number, required } from '@/utils/validators'
import { crudMixin } from '@/utils/mixins/crudMixin'
import mixins from 'vue-typed-mixins'
import { VueForm, Params, SelectItem } from '@/utils/interfaces'
import Autocomplete from '@/components/Autocomplete.vue'
import { CreateTopUpIntegrationPriceDTO } from '@/utils/interfaces/topup.integration.interface'
import { createTopUpIntegrationPrice } from '@/api/Topup/topup.integration.api'
import { getUsers } from '@/api/Users/users.api'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialog,
    appAutocomplete: Autocomplete,
  },
  data() {
    return {
      rules: {
        required: (value: string) =>
          required(value) || this.$t('validation.field-required'),
        numeric: (value: string) =>
          number((value || '').toString()) ||
          this.$t('validation.must-be-a-number'),
        greaterThan: (value: number) =>
          value >= 0 ||
          this.$t('validation.must-be-greater-than-equal', { value: 0 }),
        lowerThan: (value: number) =>
          value <= 10 ||
          this.$t('validation.must-be-lower-than-equal', { value: 10 }),
      },
      crud: {} as AgencyTopUpPrice,
      defaultCrud: {
        provider: '',
        agent: '',
        price: 19,
        product: 20,
        is_active: true,
        rate: 1,
      } as CreateTopUpIntegrationPriceDTO,
      getUsers: (params?: Params) =>
        getUsers({ ...params, role: 'INTEGRATION' }),
      getProviders: getProviders,
      loading: {
        general: false,
        products: false,
      },
      products: [] as SelectItem[],
    }
  },
  methods: {
    async onSuccess() {
      if (!(this.$refs.form as VueForm).validate()) return
      try {
        this.loading.general = true
        const response = await createTopUpIntegrationPrice(this.crud)
        this.resetCrud()
        ;(this.$refs.form as VueForm).resetValidation()
        this.$emit('new-item', response.data)
        this.$emit('input', false)
      } finally {
        this.loading.general = false
      }
    },
  },
  async mounted() {
    this.loading.products = true
    try {
      const response = await getProducts({ limit: 200 })
      this.products = response.data.results.map(product => ({
        text: product.full_code,
        value: product.uuid,
      }))
    } finally {
      this.loading.products = false
    }
  },
})
